import React, { Component } from 'react'
import { i18nTranslate } from 'src/utils'
import { Button, Modal } from 'react-bootstrap'
import './styles.scss'

class ConversionDisclaimerPopup extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      isToShowPopUp = true,
      handleConversionDisclaimerPopup,
      handleConversionDisclaimerPopupClose,
      handleShowPhoneVerificationModal,
      handleShowAccountConvertedSuccessModal,
    } = this.props

    return (
      <Modal
        show={isToShowPopUp}
        className="conversion-disclaimer-modal rounded-md modal-dialog-centered">
        <Modal.Body className="conversion-disclaimer-modal">
          <h4 className="conversion-disclaimer-modal-title">
            {i18nTranslate(
              'ba_to_member_become_a_member_disclaimer_title',
              'This process could take up to 24 hours'
            )}
          </h4>
          <p className="conversion-disclaimer-modal-content">
            {i18nTranslate(
              'ba_to_member_become_a_member_disclaimer_message',
              'Purchases placed before your account type has been changed to Member will be Brand Affiliate purchases. Please check your email for confirmation that your account type has been updated.'
            )}
          </p>
          <div className="row">
            <div className="col-5">
              <Button
                className="cancel-button rounded-md"
                variant="outline-primary"
                data-testid="qa-exit-cancel-button"
                block
                onClick={handleConversionDisclaimerPopupClose}>
                {i18nTranslate('privacy.closeButton', 'Close')}
              </Button>
            </div>
            <div className="col-7">
              <Button
                data-testid="qa-acknowledgeButton"
                className="acknowledge-button rounded-md"
                variant="primary"
                type="submit"
                onClick={handleShowAccountConvertedSuccessModal}
                block>
                {i18nTranslate(
                  'ba_to_member_confirm_and_switch_to_member',
                  'Confirm and Switch to Member'
                )}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

export default ConversionDisclaimerPopup
export { ConversionDisclaimerPopup }
